import { begatewayKeysApi, byCreated } from '@/store/api/begateway/begateway.keys.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeApiKey } from '@/types/begateway/types.begateway.key';
import { upsertById } from '@/store/api/base/api.cache';

export const writeKey = (dispatch: TypeAppDispatch, apiKey: TypeApiKey) => {
    dispatch(begatewayKeysApi.util.updateQueryData('listGatewayKeys', undefined, (draft) => {
        upsertById(draft, apiKey);
        draft.sort(byCreated);
    }));
    dispatch(begatewayKeysApi.util.updateQueryData('readGatewayKey', apiKey.id, () => apiKey));
};
